import type { TOC } from '@ember/component/template-only';
import Card from 'garaje/components/ui/card';
import type Entry from 'garaje/models/entry';
import type Invite from 'garaje/models/invite';

interface ApprovalNeedsReviewSignature {
  Args: {
    invite?: Invite;
    entry?: Entry;
  };
}

export default <template>
  <Card class="border-carbon-20 mb-8">
    <h5 class="text-sm font-bold mb-1">{{if @entry "Entry" "Invite"}} expired</h5>
    <p class="text-sm mb-0" data-test-expired-nonapprover>
      {{#if @entry}}
        Administrator did not approve entry on the day of visit.
      {{else if @invite}}
        Administrator did not approve invite before the scheduled visit.
      {{/if}}
    </p>
  </Card>
</template> satisfies TOC<ApprovalNeedsReviewSignature>;
